export const InputFieldTypes = {
  NUMERIC: 'numeric',
  TEXT: 'text',
  BOOLEAN: 'boolean'
}



// WEBPACK FOOTER //
// ./src/utils/input-field-types.js